import '@fontsource-variable/inter'
import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'

import axios from 'axios'

import PrimeVue from 'primevue/config'
import { theme } from '@/theme'
import { primeVueSl } from '@/locales/primevue.sl'
import ToastService from 'primevue/toastservice'
import DialogService from 'primevue/dialogservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'

import '@/icons'

const app = createApp(App)

axios.defaults.withCredentials = true
axios.defaults.withXSRFToken = true
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

app.use(createPinia())
app.use(router)

app.use(PrimeVue, {
	theme: {
		preset: theme,
	},
	locale: primeVueSl,
})
app.directive('tooltip', Tooltip)
app.use(ToastService)
app.use(DialogService)
app.use(ConfirmationService)

app.mount('#app')
